<div class="lei-dialog">
  <mat-dialog-content>
    <p class="title">Access Denied</p>
    <p class="message">Sorry you do not have permission to access this application.</p>
    <p class="message">Please contact Sales Support.</p>
  </mat-dialog-content>
</div>